var RelatedScroll = function(gal) {
    var _this = this,
        _isRedesign = $('.vr-slider-body').length > 0,
        _redesignRelatedMaxWidth = 300;
    
    var containerWrapper = dom.getById('container-wrapper'),
        related = dom.getById("related"),
        content = dom.getById("related-content"),
        openedRelatedLeft = related ? (_isRedesign ? related.clientWidth + 15 : 275) : 0,
        closedRelatedLeft = related ? (_isRedesign ? related.clientWidth : 281) : 0,
        isScrollOpen = false;


    function _getScroll(el, custome) {

        var top = !custome ? el.scrollTop : custome;

        return {
            top: top,
            height: el.clientHeight
        };
    }

    function _setPositions(scroll) {

        titles.style.display = "block";

        var targets = _getTargets(),
            target;

        for (var i = 0; i < targets.length; i++) {
            target = targets[i];

            _setPosition(target, scroll, i, targets.length);
        };

        target = null;

    };

    function _getTargets() {

        var target1 = false,
            target2 = false,
            target3 = false;

        var targetsArray = [];

        if (title1) {
            target1 = {
                top: title1.offsetTop,
                height: title1.clientHeight,
                body: title11,
                el: title1
            };
            targetsArray.push(target1);
        };

        if (title2) {
            target2 = {
                top: title2.offsetTop,
                height: title2.clientHeight,
                body: title22,
                el: title2
            };
            targetsArray.push(target2);
        };

        if (title3) {
            target3 = {
                top: title3.offsetTop,
                height: title3.clientHeight,
                body: title33,
                el: title3
            };
            targetsArray.push(target3);
        };

        return targetsArray;

    };

    function _setPosition(target, scroll, n, length) {

        if (length === 0) { return };

        if (target) {

            function setAtTop() {
                target.body.style.top = top + "px";
                target.body.style.display = "block";

                dom.addClass(target.body, "active");
                dom.addClass(target.el, "active");

                dom.addClass(target.body, "top");
            }

            var

                p = n ? n === 1 ? 2 : 1 : 0,

                bottom = scroll.height - target.height * p /*+ 50*/ ,
                top = target.height * n /*+ 50*/ ;

            if (length === 2) {
                bottom += 39;
            };


            if (bottom === scroll.height) {
                target.body.style.top = top + "px";
                target.body.style.display = "block";

                dom.addClass(target.body, "active");
                dom.addClass(target.el, "active");
                dom.addClass(target.body, "top");
            }

            /**
             * Set at Bottom
             */
            if (target.top > bottom) {
                target.body.style.top = bottom + "px";
                target.body.style.display = "block";
            }

            /**
             * Set as Normal ( Scrolling )
             */
            if (scroll.top >= target.el.offsetTop - bottom) {
                target.body.style.top = "";
                target.body.style.display = "none";

                dom.removeClass(target.body, 'top');
                dom.removeClass(target.body, "active");
                dom.removeClass(target.el, "active");


            }

            /**
             * Set at Top
             */
            if (scroll.top > target.el.offsetTop - top && !dom.hasClass(target.body, "top")) {
                setAtTop();
            } else if (bottom === scroll.height) {
                setAtTop();
            }


        };

    };

    if (typeof offerista_tracking !== "undefined" && offerista_tracking) {
        var pendingBrochureLeftImpressionsArr = [];

        function genereateImpressionTrackingData() {
            var brochuresLeftImpressionTracking = new OfferistaTracking();
            var brochuresObjectsArray = [];    

            for (i=0; i<pendingBrochureLeftImpressionsArr.length; i++) {
                brochuresObjectsArray[i] = (new OfferistaTracking()).data.trackings[0];
                brochuresObjectsArray[i].type = "BROCHURE_IMPRESSION"
                brochuresObjectsArray[i].objectId = pendingBrochureLeftImpressionsArr[i];
            }
            
            brochuresLeftImpressionTracking.sendTracking({fn: "offeristaTracking", trackings: brochuresObjectsArray});
            pendingBrochureLeftImpressionsArr = [];
        }

        function brochuresLeftImpressionTracking() {
            var brochuresLeftSelector = $('.related-panel .catalog'),
                sliderHeight = $('#related').height();

            $.each(brochuresLeftSelector, function(_, el){
                if ( $(el).position().top <= sliderHeight && $(el).position().top >= 0 ) {

                    var id = Number($(el).find('.catalog-image').attr('data-offerista-id'));

                    if ( sentBrochureImpressionsArr.indexOf(id) === -1 ) {
                        sentBrochureImpressionsArr.push(id);
                        pendingBrochureLeftImpressionsArr.push(id);
                    }

                } 
                if ( $(el).position().top > sliderHeight ) {
                    return false;
                }
            });

            if ( pendingBrochureLeftImpressionsArr.length > 0 ) {
                genereateImpressionTrackingData();
            }
        }
    }

    if (typeof brochure_impression_statistics !== "undefined" && brochure_impression_statistics) {
        var pendingBrochureLeftImpressionsStatArr = [];

        function sendLeftImpressionsStat() {
            var device = (isMobile || isTablet) ? 'mobile' : 'desktop';

            function createUUID() {
                return 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            };

            function setCookie(name, value, days) {
                var d = new Date;
                d.setTime(d.getTime() + 24*60*60*1000*days);
                document.cookie = name + "=" + value + ";path=/;expires=" + d.toUTCString();
            }

            function getCookie(name) {
                var value = "; " + document.cookie;
                var parts = value.split("; " + name + "=");
                if (parts.length === 2) return parts.pop().split(";").shift();
            }

            if (document.cookie.indexOf('uid=') !== -1) {
                uuid = getCookie('uid');
            } else {
                uuid = createUUID();
                setCookie('uid', uuid, 365);
            }

            $.ajax({
                type: "POST",
                url: '/ajx/ajax.file.php',
                contentType: "application/json",
                data: JSON.stringify({
                    impressions: pendingBrochureLeftImpressionsStatArr,
                    device: device,
                    userUuid: uuid,
                    fn: "brochureImpressions"
                }),
                dataType: 'json',
                success: function(data){
                    
                },
                error: function(err){}
            });

            pendingBrochureLeftImpressionsStatArr = [];
        }

        function brochuresLeftImpressionStat() {
            var brochuresLeftSelector = $('.related-panel .catalog'),
                sliderHeight = $('#related').height();

            $.each(brochuresLeftSelector, function(_, el){
                if ( $(el).position().top <= sliderHeight && $(el).position().top >= 0 ) {

                    var id = Number($(el).find('.catalog-image').attr('data-brochure-id'));

                    if ( sentBrochureImpressionsArray.indexOf(id) === -1 ) {
                        sentBrochureImpressionsArray.push(id);
                        pendingBrochureLeftImpressionsStatArr.push(id);
                    }

                } 
                if ( $(el).position().top > sliderHeight ) {
                    return false;
                }
            });

            if ( pendingBrochureLeftImpressionsStatArr.length > 0 ) {
                sendLeftImpressionsStat();
            }
        }
    }

    if (related) {
        scrollbarRelated = new IScroll(dom.getAll("#related .viewport")[0], {
            mouseWheel: true,
            scrollbars: true,
            interactiveScrollbars: true,
            fadeScrollbars: false,
            zIndex: 'auto',
            bounce: false,
            mouseWheelSpeed: 60
        });

        if (typeof offerista_tracking !== "undefined" && offerista_tracking && $("#related").is(":visible") ) {
            brochuresLeftImpressionTracking();
        }

        if (typeof brochure_impression_statistics !== "undefined" && brochure_impression_statistics) {
            brochuresLeftImpressionStat();
        }

        scrollbarRelated.on('scrollStart', function(){
            bLazy.load($('#related .b-lazy').get());
            if (typeof offerista_tracking !== "undefined" && offerista_tracking) {
                brochuresLeftImpressionTracking();
            }
            if (typeof brochure_impression_statistics !== "undefined" && brochure_impression_statistics) {
                brochuresLeftImpressionStat();
            }
        });

        _this.scrollbarRelated = scrollbarRelated;

        /**
         * On window resize update Scrollbar Size/Position and Scrollbar Titles Position
         */

        /* Titles */

        var tab1 = dom.getAll(".related-tab")[0],
            tab2 = dom.getAll(".related-tab")[1],
            tab3 = dom.getAll(".related-tab")[2];

        var title1 = tab1 ? dom.getChildByClass(tab1, 'related-title') : false,
            title2 = tab2 ? dom.getChildByClass(tab2, 'related-title') : false,
            title3 = tab3 ? dom.getChildByClass(tab3, 'related-title') : false;

        var titles = dom.getById("related-titles");

        var title11 = titles ? titles.querySelectorAll(".related-title")[0] : false,
            title22 = titles ? titles.querySelectorAll(".related-title")[1] : false,
            title33 = titles ? titles.querySelectorAll(".related-title")[2] : false;

        _setPositions(_getScroll(content));

        content.addEventListener("scroll", function(event) {
            var scroll = _getScroll(this);
        });

        /** Related Btn */

        isScrollOpen = true;
        var relatedBtn = dom.getById('related-btn');
        relatedBtn.addEventListener('click', function() {

            if (isScrollOpen) {
                scrollClose();
                return;
            };

            scrollOpen();

        }, true);

        function isReversed() {

            return md.mobile();

            return window.innerWidth <= 1000 && window.innerHeight <= 1000;
        }

        /* Close Related */
        function scrollClose(callback) {
            if (typeof related === 'undefined' || !related || isScrollOpen == false) {
                return;
            }

            var current, end, move;

            if (!gal.gallery) return;

            function update(now) {
                related.style.left = now.x + 'px';
                containerWrapper.style.left = (_isRedesign ? now.x2 : (now.x2 - 43)) + 'px';
                gal.gallery.updateSize(true); // slider.resize();

                fireEvent(document, 'view.slider.zoom');
            }

            function complete() {
                isScrollOpen = false;
                dom.addClass(relatedBtn, 'closed');
                dom.removeClass(relatedBtn, 'open');

                if (isReversed()) {
                    dom.addClass(relatedBtn, 'open');
                    dom.removeClass(relatedBtn, 'closed');
                };

                gal.resizePageButtons();

                if (typeof callback === 'function') {
                    callback();
                }
            }

            current = { x: (_isRedesign ? 0 : 60), x2: openedRelatedLeft };
            move = _isRedesign ? _redesignRelatedMaxWidth : related.clientWidth - 63;
            end = { x: -move, x2: (_isRedesign ? 15 : openedRelatedLeft - move - 20) };

            if (isReversed()) {
                current = { x: -197, x2: 3 };
                move = related.clientWidth;
                end = { x: 0, x2: 200 };
            };

            ani.play("scrollClose", current, end, 333, easing.easeOutSine, update, complete);

        }

        /* Open Related*/
        function scrollOpen(callback) {
            if (typeof related === 'undefined' || !related) {
                return;
            }

            var current, end, move;

            function update(now) {
                related.style.left = now.x + 'px';
                containerWrapper.style.left = (now.x2) + 'px';
                gal.gallery.updateSize(true);
                fireEvent(document, 'view.slider.zoom');
            }

            function complete() {
                isScrollOpen = true;
                dom.addClass(relatedBtn, 'open');
                dom.removeClass(relatedBtn, 'closed');

                if (isReversed()) {
                    dom.addClass(relatedBtn, 'closed');
                    dom.removeClass(relatedBtn, 'open');
                };

                gal.resizePageButtons();

                if (typeof callback === 'function') {
                    callback();
                }
            }

            current = _isRedesign ? current = { x: -openedRelatedLeft, x2: 0 } : { x: -137, x2: 124 };
            move = _isRedesign ? _redesignRelatedMaxWidth : related.clientWidth - 63;
            end = { x: (_isRedesign ? 0 : 60), x2: openedRelatedLeft };

            if (isReversed()) {
                current = { x: 0, x2: 200 };
                move = related.clientWidth;
                end = { x: -197, x2: 3 };
            };

            ani.play("scrollOpen", current, end, 333, easing.easeOutSine, update, complete);
        }

        window.addEventListener('ui.oncloseall', function() {
            if (md.mobile()) {
                if (!isScrollOpen) {
                    scrollOpen(); // Close
                };
            };
        }, true);


        /** click Scroll TO */

        var titleSearchProducts = dom.getById('related-from-search');
        var titleBrand = dom.getById('related-from-brand');
        var titleCategory = dom.getById('related-from-category');

        var titleSearchProductsTarget = dom.getById('related-from-search-target');
        var titleBrandTarget = dom.getById('related-from-brand-target');
        var titleCategoryTarget = dom.getById('related-from-category-target');

        function _getTitleTop(event) {
            var targetID = event.target.parentNode.id + '-target';
            var tab = dom.getById(targetID);
            var n = 0;

            if (tab === titleBrandTarget) { n = 1; };
            if (tab === titleCategoryTarget) { n = 2; };

            var length = _getTargets().length;

            if (length === 2) { n = 1; };

            var top = -tab.offsetTop + 39 * n;


            scrollbarRelated.animateUpdate(top, false, function(now) {
                _setPositions(_getScroll(related, Math.abs(now.scroll2)));
            });

        }

        if (titleSearchProducts) {
            titleSearchProducts.addEventListener('click', function(event) {
                _getTitleTop(event);
            }, true);
        };

        if (titleBrand) {
            titleBrand.addEventListener('click', function(event) {
                _getTitleTop(event);
            }, true);
        };

        if (titleCategory) {
            titleCategory.addEventListener('click', function(event) {
                _getTitleTop(event);
            }, true);
        };


    } else {
        dom.addClass(containerWrapper, 'no-related');
    }

    function _isScrollOpen() {
        return isScrollOpen;
    }

    function _handleScrollRefresh(){
        /* Refresh iScroll height when, b-lazy images for desktop related left brochrues, load. */
        window.addEventListener('view.related.left.img.loaded', function(e) {
            if(!isMobile && typeof relatedScroll !== 'undefined' && relatedScroll.scrollbarRelated){
                relatedScroll.scrollbarRelated.refresh();
            }
        });        
    }
    

    function _init(){
        _handleScrollRefresh();
    }

    _init();

    _this.scrollOpen = scrollOpen;
    _this.scrollClose = scrollClose;
    _this.isScrollOpen = _isScrollOpen;
};
